<template>
	<router-view />
</template>

<script>
export default {
	name: 'DashboardAll',
	computed: {},
	components: {},
};
</script>
